module.exports = __webpack_public_path__ + "media/images/social/vv_01-ee5b64f66eeee412cda5cb44a7e97fb6.jpg";